//#region src/assets/whatsapp.svg
var whatsapp_default = "" + new URL("whatsapp-BPc3gPHh.svg", import.meta.url).href;
//#endregion
export { whatsapp_default as default };

//# sourceMappingURL=whatsapp.js.map